import * as React from "react";
const SvgCart20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M.476 3.338h1.61L4.506 15v.002H16.55l.345-1.666H5.862l-.346-1.669h11.725l1.555-7.5h-1.702v.004H3.96L3.442 1.67l-.01.003H.475v1.666Zm4.694 6.663h10.714l.863-4.163H4.307L5.17 10Z",
      clipRule: "evenodd"
    }),
    React.createElement("path", {
      fill: "current",
      d: "M8.287 17.392a1.775 1.775 0 1 1-3.55 0 1.775 1.775 0 0 1 3.55 0Zm8.025 0a1.775 1.775 0 1 1-3.55 0 1.775 1.775 0 0 1 3.55 0Z"
    })
  );
export default SvgCart20Px;
